import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import AuthenticatedLayout from 'layout/BHSi/AuthenticatedLayout';

const ClientDetails = Loadable(lazy(() => import('pages/bhsi/ClientDetails')));
const Cms = Loadable(lazy(() => import('pages/bhsi/Cms')));
const HotelDetails = Loadable(lazy(() => import('pages/bhsi/HotelDetails')));
const Invoice = Loadable(lazy(() => import('pages/bhsi/Invoice')));
const InvoiceOnAccount = Loadable(lazy(() => import('pages/bhsi/InvoiceOnAccount')));
const RoomReservation = Loadable(lazy(() => import('pages/bhsi/RoomReservation')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <AuthenticatedLayout />,
  children: [
    {
      path: 'clients',
      element: <ClientDetails />
    },
    {
      path: 'hotels',
      children: [
        {
          path: 'details',
          element: <HotelDetails />
        }
      ]
    },
    {
      path: 'room-reservation',
      element: <RoomReservation />
    },
    {
      path: 'invoice',
      element: <Invoice />
    },
    {
      path: 'invoice-on-account',
      element: <InvoiceOnAccount />
    },
    {
      path: 'cms',
      element: <Cms />
    }
  ]
};

export default MainRoutes;
